// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"Scrollbars_scrollbars__2yM4J","big":"Scrollbars_big__1bQqz"};